/*
 * Copyright (C) 2022 by attentus GmbH
 * All Rights Reserved
 * https://www.attentus.com
 * jeckplan@attentus.com
 *
 * This source code is proprietary and confidential. Unauthorized
 * copying of this file via any medium is strictly prohibited and
 * lead to legal consequences.
 *
 * @package Jeckplan
 * @author  Joachim Binnemann <binnemann@attentus.com>
 * @author  Kolja Nolte <nolte@attentus.com>
 */

// Silence jQuery Migrate messages
jQuery.migrateMute = true;

/**
 * Sets the loading state of buttons.
 */
function btnLoading(elem) {
  jQuery(elem).attr("data-original-text", jQuery(elem).html());
  jQuery(elem).prop("disabled", true);
  jQuery(elem).html('<i class="fa fa-refresh fa-spin"></i> Laden...');
}

/**
 * Sets the sending state of buttons.
 */
function btnSending(elem) {
  jQuery(elem).attr("data-original-text", jQuery(elem).html());
  jQuery(elem).prop("disabled", true);
  jQuery(elem).html('<i class="fa fa-refresh fa-spin"></i> Senden...');
}

/**
 * Sets the saving state of buttons.
 */
function btnSaving(elem) {
  jQuery(elem).attr("data-original-text", jQuery(elem).html());
  jQuery(elem).prop("disabled", true);
  jQuery(elem).html('<i class="fa fa-refresh fa-spin"></i> Speichern...');
}

/**
 * Sets the deleting state of buttons.
 */
function btnDeleting(elem) {
  jQuery(elem).attr("data-original-text", jQuery(elem).html());
  jQuery(elem).prop("disabled", true);
  jQuery(elem).html('<i class="fa fa-refresh fa-spin"></i> Löschen...');
}

/**
 * Resets the state of buttons.
 */
function btnReset(elem) {
  jQuery(elem).addClass("btn-success");
  jQuery(elem).html('<i class="fa fa-check"></i> Fertig');
  jQuery(elem).prop("disabled", false);
  setTimeout(function () {
    jQuery(elem).removeClass("btn-success");
    jQuery(elem).html(jQuery(elem).attr("data-original-text"));
  }, 1000);
}

const loadingHTML =
  '<div id="loading-html" class="alert d-flex justify-content-center loading-html"><div class="spinner-border text-jeck-red" role="status"><span class="sr-only">Laden...</span></div></div>';
function updateProgressBar(progressBar, loaded, total, label) {
  var current = progressBar.attr("aria-valuenow");
  var percent = Math.floor((loaded / total) * 100);
  let progressWrap = progressBar.parents(".progress-wrap");
  let progressLabel = progressWrap.find(".progress-label");
  //console.log('current: ' + current + ', loaded: ' + loaded + ', percent: ' + percent);

  if (percent > 100) {
    percent = 100;
  }

  progressBar.text(percent + "%");
  progressBar.attr("aria-valuenow", percent);
  progressBar.css("width", percent + "%");

  if (label) {
    progressLabel.text(label);
  }

  if (percent == 0) {
    progressWrap.removeClass("d-none");
    progressBar.css("display", "block");
  }
  if (percent == 100) {
    progressLabel.html("");
    progressBar.text("");
    setTimeout(function () {
      progressBar.fadeOut();
      progressWrap.addClass("d-none");
    }, 1000);
  }
}

function setProgressBar(progressBar, percent, label) {
  let progressWrap = progressBar.parents(".progress-wrap");
  let progressLabel = progressWrap.find(".progress-label");
  if (percent > 100) {
    percent = 100;
  }

  progressBar.text(percent + "%");
  progressBar.attr("aria-valuenow", percent);
  progressBar.css("width", percent + "%");

  if (label) {
    progressLabel.text(label);
  }

  if (percent == 0) {
    progressWrap.removeClass("d-none");
    progressBar.css("display", "block");
  }
  if (percent == 100) {
    progressLabel.html("");
    progressBar.text("");
    setTimeout(function () {
      progressBar.fadeOut();
      progressWrap.addClass("d-none");
    }, 1000);
  }
}
/**
 * Shows a progress modal with a title and message.
 * @param {string} title - The title of the modal.
 * @param {string} message - The message to display in the modal.
 */
function showProgressModal(title, message) {
  const $modal = jQuery("#modal-progress-bar");

  // Handle modal hidden event
  $modal.on("hidden.bs.modal", function () {
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
  });

  $modal.modal("show");
  $modal.find(".modal-title").html(title);
  $modal.find(".progress-label").html(message);
}

/**
 * Updates the progress modal with a message and progress.
 * @param {string} message - The message to display in the modal.
 * @param {number} progress - The progress to display in the modal.
 */
function updateProgressModal(message, progress) {
  const $modal = jQuery("#modal-progress-bar");
  $modal.find(".progress-label").html(message);
  $modal.find(".progress-wrap").removeClass("d-none");
  $modal.find(".progress-bar").css("width", progress + "%");
}

/**
 * Hides the progress modal.
 */
function hideProgressModal() {
  const $modal = jQuery("#modal-progress-bar");
  $modal.find(".progress-label").html("");
  $modal.find(".progress-wrap").addClass("d-none");
  $modal.modal("hide");
}

/**
 * Stores checkboxes in allTablesCheckboxes[]
 */
function storeTableCheckboxes(tableID) {
  let table = document.getElementById(tableID);
  let tableCheckboxes = table.querySelectorAll('input[type="checkbox"]:not(.table-check-toggler)');
  if (table.classList.contains("ajax-sort-table") === false) {
    allTablesCheckboxes[tableID] = {};
  }
  for (var j = 0; j < tableCheckboxes.length; j++) {
    var box = tableCheckboxes[j];
    var arr = [];
    var dataset = box.dataset;
    for (var d in dataset) {
      arr[d] = dataset[d];
    }
    arr["checked"] = box.checked;
    allTablesCheckboxes[tableID][arr["id"]] = arr;
  }
  console.log("store allTablesCheckboxes[" + tableID + "]: ", allTablesCheckboxes[tableID]);
}

/**
 * Reinit functions after ajax calls/rerendering elements
 */
function reInitCheckboxes() {
  /**
   * Toggles checkboxes in table columns
   */
  jQuery(".table-check-toggler").click(function () {
    var tableID = jQuery(this).closest("table").attr("id");
    jQuery(this).closest("table").find("input:checkbox").prop("checked", jQuery(this).is(":checked"));
    if (allTablesCheckboxes[tableID] === undefined) {
      allTablesCheckboxes[tableID] = {};
    }
    if (allTablesCheckboxes[tableID] !== undefined) {
      if (jQuery("#" + tableID).hasClass("ajax-sort-table")) {
        storeTableCheckboxes(tableID);
      }
      for (key in allTablesCheckboxes[tableID]) {
        allTablesCheckboxes[tableID][key]["checked"] = jQuery(this).is(":checked");
      }
    }
    console.log("toggle allTablesCheckboxes[" + tableID + "]: ", allTablesCheckboxes[tableID]);
  });

  /**
   * Stores checkboxes states in allTablesCheckboxes[]
   */
  jQuery("table input:checkbox:not(.table-check-toggler)").on("change", function () {
    var elementID = jQuery(this).data("id");
    var tableID = jQuery(this).closest("table").attr("id");
    if (allTablesCheckboxes[tableID] === undefined) {
      allTablesCheckboxes[tableID] = {};
      console.log("undefined allTablesCheckboxes[" + tableID + "]: ", allTablesCheckboxes[tableID]);
    }
    if (allTablesCheckboxes[tableID][elementID] === undefined) {
      var box = jQuery(this);
      var arr = [];
      var dataset = box.data();
      for (var d in dataset) {
        arr[d] = dataset[d];
      }
      arr["checked"] = box.is(":checked");
      allTablesCheckboxes[tableID][arr["id"]] = arr;
      console.log(
        "undefined allTablesCheckboxes[" + tableID + "][" + elementID + "]: ",
        allTablesCheckboxes[tableID][elementID]
      );
    } else if (elementID !== undefined && allTablesCheckboxes[tableID] !== undefined) {
      allTablesCheckboxes[tableID][elementID]["checked"] = this.checked;
      console.log("defined allTablesCheckboxes[" + tableID + "][" + elementID + "][checked]: ", this.checked);
    }
    console.log("change allTablesCheckboxes[" + tableID + "]: ", allTablesCheckboxes[tableID]);
  });
}

/**
 * Toggles checkboxes states stored in allTablesCheckboxes[]
 */
function checkTableCheckboxes(tableID) {
  let table = document.getElementById(tableID);
  let tableCheckToggler = table.getElementsByClassName("table-check-toggler")[0];
  if (allTablesCheckboxes[tableID] !== undefined) {
    let boxes = table.querySelectorAll('input[type="checkbox"]:not(.table-check-toggler)');
    let checkedBoxes = 0;
    for (i = 0; i < boxes.length; ++i) {
      var boxID = boxes[i].getAttribute("data-id");
      if (allTablesCheckboxes[tableID][boxID] !== undefined) {
        boxes[i].checked = allTablesCheckboxes[tableID][boxID]["checked"];
        if (boxes[i].checked) {
          checkedBoxes++;
        }
        //console.log('boxes[' + i + '].checked: ', boxes[i].checked);
        //console.log('allTablesCheckboxes[' + tableID + '][' + boxID + ']: ', allTablesCheckboxes[tableID][boxID]);
      }
    }

    if (tableCheckToggler) {
      if (boxes.length === checkedBoxes) {
        tableCheckToggler.checked = true;
      } else {
        tableCheckToggler.checked = false;
      }
    }
    //console.log('check allTablesCheckboxes[' + tableID + ']: ', allTablesCheckboxes[tableID]);
  }
  reInitCheckboxes();
}

jQuery(document).ready(function ($) {
  const progressModalElement = document.getElementById("modal-progress-bar");
  const progressModal = $("#modal-progress-bar");
  const modalProgressBar = progressModal.find("#progress-bar");

  Date.prototype.timestamp = function () {
    var yyyy = this.getFullYear().toString();
    var mm = (this.getMonth() + 1).toString();
    var dd = this.getDate().toString();
    var hh = this.getHours().toString();
    var ii = this.getMinutes().toString();
    var ss = this.getSeconds().toString();
    return (dd[1] ? dd : "0" + dd[0]) + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + yyyy + "_" + hh + "-" + ii + "-" + ss;
  };

  /**
   * Toggles the content of cards up and down.
   */
  $(".card .card-toggler").on("click", function () {
    $(this).closest(".card").find(".card-body").slideToggle("fast");
    $(this).toggleClass("collapsed");
  });

  /**
   * Toggles the visibility for the Childs in Member Site.
   * TODO: Add more Childs than 4. Array? Maybe new Table in Database?
   * TODO: Add Function with Macro in Twig?
   */

  var currentIndex = -1;
  var elements = ["#childWrapper_1", "#childWrapper_2", "#childWrapper_3", "#childWrapper_4"];
  for (var i = 0; i < elements.length; i++) {
    if ((i == 0 && $("#child_first_name").val()) || (i != 0 && $("#child_first_name_" + i).val())) {
      $(elements[i]).removeClass("hidden");
    }
  }

  $("#add-child-button").click(function (e) {
    e.preventDefault();
    // update the currentIndex
    currentIndex = (currentIndex + 1) % elements.length;
    // show the next element
    $(elements[currentIndex]).removeClass("hidden");
  });

  $(".remove-child-button").click(function (e) {
    e.preventDefault();
    var childId = $(this).data("child-id");
    var currentWrapper = $("#childWrapper_" + childId);
    currentWrapper.addClass("hidden");
    // clear the input values
    currentWrapper.find("input").val("");
  });

  /**
   * Toggle visibilty for second Partner
   */
  $("#add-partner-button").click(function (e) {
    e.preventDefault();
    $("#second_marriage_partner_wrapper").removeClass("hidden");
    $("#add-partner-button").addClass("hidden");
  });

  $(".remove-partner-button").click(function (e) {
    e.preventDefault();
    var currentWrapper = $("#second_marriage_partner_wrapper");
    currentWrapper.addClass("hidden");
    currentWrapper.find("input").val("");
    $("#add-partner-button").removeClass("hidden");
  });

  //Check if Email or debtor number exists
  $("#new-user").on("submit", function (e) {
    e.preventDefault();

    console.log("submit");
    var nonce = $("#check_email_nonce").val();
    var userID = $("#edit_user_id").val();
    var email = $("#email").val();
    var currentEmail = $("#email").data("email-old");
    var debtorNumber = $("#debtor-number").val();
    var currentDebtorNumber = $("#debtor-number").data("debtor-number-old");
    var memberID = $("#member-id").val();
    var currentMemberID = $("#member-id").data("member-id-old");
    var previousRole = "";
    previousRole = $("#previous-role").val();
    console.log("previousRole: ", previousRole);
    if (
      (email != currentEmail || debtorNumber != currentDebtorNumber || memberID != currentMemberID) &&
      previousRole == undefined
    ) {
      $.ajax({
        url: ajax_url,
        type: "POST",
        data: {
          action: "check_email",
          check_email_nonce: nonce,
          user_id: userID,
          email: email,
          debtor_number: debtorNumber,
          member_id: memberID,
        },
        success: function (response) {
          if (response.data.email == "exists") {
            $("#email").prev().text("Diese E-Mail-Adresse existiert bereits!").css("color", "#e11d48");
            $("#email").addClass("alert-danger");
            $("html, body").animate(
              {
                scrollTop: $("#email").offset().top - 100,
              },
              500
            );
            return false;
          } else if (response.data.debtor_number == "exists") {
            $("#debtor-number").prev().text("Diese Debitorennummer existiert bereits!").css("color", "#e11d48");
            $("#debtor-number").addClass("alert-danger");
            $("html, body").animate(
              {
                scrollTop: $("#debtor-number").offset().top - 100,
              },
              500
            );
            return false;
          } else if (response.data.member_id == "exists") {
            $("#member-id").prev().text("Diese Mitgliedsnummer existiert bereits!").css("color", "#e11d48");
            $("#member-id").addClass("alert-danger");
            $("html, body").animate(
              {
                scrollTop: $("#member-id").offset().top - 100,
              },
              500
            );
            return false;
          } else {
            $("#new-user").unbind("submit").submit();
          }
        },
      });
    } else {
      $("#new-user").unbind("submit").submit();
    }
  });

  /**
   * Toggles the visibility of form elements.
   */
  $(".form-toggler").on("change", function () {
    var toggleElementID = $(this).data("toggle-form-id");
    $("#" + toggleElementID).toggleClass("d-none");

    var toggleID = $(this).data("toggle-id");

    if (toggleID) {
      console.log("toggleID: ", toggleID);
      $("#" + toggleID).val("");
    }
  });

  /**
   * Toggles other input elements if they are checked.
   */
  $(".switch-toggler").on("click", function () {
    var isChecked = $(this).prop("checked");
    var toggleInputID = $(this).attr("data-toggle-input-id");
    if ($("#" + toggleInputID).is(":checked")) {
      //$('#' + toggleInputID).click();
      $("#" + toggleInputID)
        .prop("checked", false)
        .trigger("change");
    }

    $(this).prop("checked", isChecked);
  });

  /**
   * Toggles the 'active' state of buttons in button groups
   */
  $(".btn-toggle-group").on("click", ".btn", function () {
    $(this).addClass("active").siblings().removeClass("active");
  });

  reInitCheckboxes();

  /**
   * Wrap ajax-sort-table th elements with dataTable-sorter elements.
   */
  $(".ajax-sort-table th")
    .not("[data-sortable='false']")
    .wrapInner(function () {
      return "<a class='dataTable-sorter'></a>";
    });

  $("#search-date").on("change", function () {
    var selectedValue = $(this).val();
    
    // Always clear range input values and hidden field when switching
    $("input[name='search_date_range']").remove();
    $("select[name='date_day_from'], select[name='date_month_from'], select[name='date_day_to'], select[name='date_month_to']").val("");
    
    if (selectedValue != "") {
      // Check if it's a date range field
      if (selectedValue.endsWith("_range")) {
        // Clear regular date inputs when switching to range
        $("input[name='search_from'], input[name='search_to']").val("");
        
        // Hide regular date fields and show date range fields
        $(".search-date-field").addClass("hidden");
        $(".search-date-range-field").removeClass("hidden");
        
        // Set the search_date_range value based on the selected option
        var dateFieldName = selectedValue.replace("_range", "");
        $(this).closest("form").append('<input type="hidden" name="search_date_range" value="' + dateFieldName + '">');
      } else {
        // Hide date range fields and show regular date fields
        $(".search-date-range-field").addClass("hidden");
        $(".search-date-field").removeClass("hidden");
      }
    } else {
      // Hide both types of fields and clear all date inputs
      $(".search-date-field").addClass("hidden");
      $(".search-date-range-field").addClass("hidden");
      $("input[name='search_from'], input[name='search_to']").val("");
    }
  });

  // Handle member group selection to show/populate rank dropdown
  $("select[name='search_group']").on("change", function () {
    var selectedGroup = $(this).val();
    var rankField = $(".search-rank-field");
    var rankSelect = $("#search-rank");
    
    if (selectedGroup != "") {
      // Show the rank field
      rankField.removeClass("hidden");
      
      // Clear current rank options
      rankSelect.html('<option value="">Rang wird geladen...</option>');
      
      // Fetch ranks for the selected group
      $.ajax({
        url: ajax_url,
        type: "POST",
        data: {
          action: "get_group_ranks",
          nonce: $("#filter_items_nonce").val(),
          group_slug: selectedGroup
        },
        success: function (response) {
          if (response.success) {
            // Clear and populate rank dropdown
            rankSelect.html('<option value="">Rang auswählen</option>');
            $.each(response.data.ranks, function (index, rank) {
              rankSelect.append('<option value="' + rank.value + '">' + rank.text + '</option>');
            });
          } else {
            rankSelect.html('<option value="">Keine Ränge gefunden</option>');
            console.error("Error fetching ranks:", response.data);
          }
        },
        error: function (xhr, status, error) {
          rankSelect.html('<option value="">Fehler beim Laden</option>');
          console.error("AJAX error:", error);
        }
      });
    } else {
      // Hide rank field when no group is selected
      rankField.addClass("hidden");
      rankSelect.val("").html('<option value="">Rang auswählen</option>');
    }
  });

  var currentCSVData = "";

  /**
   * Filters by form elements.
   * @param {Event|string} eventOrFormId - Either an event object or a form ID string
   */
  window.handleFilterFormEvent = function (eventOrFormId) {
    let currentInput, filterForm;

    // Handle both event object and form ID cases
    if (typeof eventOrFormId === "string") {
      // If form ID is provided, get the form and its filter button
      filterForm = $("#" + eventOrFormId);
      currentInput = filterForm.find(".filter-button");
    } else {
      // Original event handling logic
      eventOrFormId.preventDefault();
      currentInput = $(this);
      filterForm = currentInput.parents(".filter-form");

      if (currentInput.hasClass("btn-export-filter-table")) {
        var filterFormID = currentInput.data("filter-form-id");
        filterForm = $("#" + filterFormID);
        var currentButton = currentInput;
        var modalTitle = currentButton.data("modal-title");
      }
    }

    let filterItems = filterForm.find(".filter-items").val();
    let filterItemContainer = filterForm.data("filter-item-container");
    let filterItemTableID = filterForm.data("filter-item-table");
    let filterItemTableHead = filterForm.data("filter-item-table-head");
    let filterItemTablePagination = filterForm.data("filter-item-table-pagination");
    let filterButton = filterForm.find(".filter-button");
    let hiddenFields = filterForm.find(".hidden-field");
    let resetButton = filterForm.find(".reset-button");
    let exportForm = $("#acui_exporter");
    let progressItemName = currentInput.data("progress-item-name");
    let activeFiltersCount = filterForm.find(".activeFiltersCount");

    // Only check event type if we're handling an event
    if (
      typeof eventOrFormId !== "string" &&
      eventOrFormId.type == "click" &&
      currentInput.prop("type") != "button" &&
      !currentInput.hasClass("dataTable-sorter")
    ) {
      return;
    }

    if (currentInput.hasClass("reset-button")) {
      filterForm.trigger("reset");
      if (exportForm != undefined) {
        exportForm.trigger("reset");
        // remove hidden-export-inputs from exportForm
        exportForm.find(".hidden-export-input").remove();
      }
      resetButton.addClass("d-none");
      if (!hiddenFields.hasClass("hidden")) {
        hiddenFields.addClass("hidden");
      }
      
      // Reset search date dropdown and trigger change event to hide date fields
      $("#search-date").val("").trigger("change");
      
      // Reset search group and rank dropdowns
      $("select[name='search_group']").val("").trigger("change");
      
      // Remove any date range hidden inputs
      $("input[name='search_date_range']").remove();
    }

    if (currentInput.hasClass("dataTable-sorter")) {
      let sorterParent = currentInput.parent();
      // Remove all TH tags with an "active" class
      if (filterForm.find("th").removeClass("active")) {
        // Set "active" class to the clicked TH tag
        sorterParent.addClass("active");
        filterForm.find("th").not(".active").removeClass("active").removeClass("desc").removeClass("asc");
      }
      if (!sorterParent.hasClass("asc")) {
        sorterParent.addClass("asc");
        if (sorterParent.hasClass("desc")) {
          sorterParent.removeClass("desc");
        }
      } else {
        sorterParent.removeClass("asc");
        if (!sorterParent.hasClass("desc")) {
          sorterParent.addClass("desc");
        }
      }
    }

    if (currentInput.hasClass("filter-input") && exportForm != undefined) {
      let inputName = currentInput.attr("name");
      let inputVal = currentInput.val();
      let hiddenInput = exportForm.find('input[name*="' + inputName + '"]');

      if (hiddenInput.length !== 0) {
        hiddenInput.val(inputVal);
      } else {
        $(
          '<input class="hidden-export-input" type="hidden" name="' + inputName + '" value="' + inputVal + '"/>'
        ).appendTo(exportForm);
      }
    }

    let nonce = $("#filter_items_nonce").val();
    let form_data = getFilterFormFormData(filterForm, currentInput);

    console.log("[main.js handleFilterFormEvent] currentInputValue: ", currentInput.val());
    console.log("[main.js handleFilterFormEvent] form_data: ", form_data);

    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "filter_items",
        nonce: nonce,
        form_data: form_data,
      },
      beforeSend: function (xhr) {
        if (currentButton != undefined) {
          btnLoading(currentButton);
        }
        if (currentInput.hasClass("btn-export-filter-table")) {
          if (modalTitle !== undefined) {
            progressModal.find(".modal-title").html(modalTitle);
          }
          progressModal.modal("show");
          setProgressBar(modalProgressBar, "0", progressItemName);
        }
        if (filterItemTableID !== undefined) {
          $("#" + filterItemTableID).slideUp();
          if (allTables[filterItemTableID] !== undefined) {
            allTables[filterItemTableID].destroy();
          }
        }
        if (filterItemTablePagination !== undefined) {
          $("#" + filterItemTablePagination).slideUp();
        }
        $(loadingHTML).insertAfter("#" + filterItemTableID);
      },
      success: function (response) {
        console.log("[main.js handleFilterFormEvent] filter success: ", response);
        filterForm.find(".loading-html").remove();
        if (filterItemTableHead !== undefined && response.data.table_head != "") {
          $("#" + filterItemTableHead).html(response.data.table_head);
          $("#" + filterItemTableHead + " th")
            .not('[data-sortable="false"]')
            .not(":has(.dataTable-sorter)")
            .each(function () {
              var $th = $(this);
              var content = $th.html();
              $th.empty().append($('<a class="dataTable-sorter"></a>').html(content));
            });
          $("#" + filterItemTableHead).slideDown();
        }
        if (response.data.filtered_items != "") {
          $("#" + filterItemContainer).html(response.data.filtered_items);
        }
        if (
          resetButton !== undefined &&
          !currentInput.hasClass("reset-button") &&
          !currentInput.hasClass("no-filter") &&
          typeof eventOrFormId !== "string"
        ) {
          resetButton.removeClass("d-none");
        }

        if (filterItemTablePagination !== undefined && response.data.table_pagination != "") {
          $("#" + filterItemTablePagination).html(response.data.table_pagination);
          $("#" + filterItemTablePagination).slideDown();
        }

        if (filterItemTableID !== undefined) {
          if (allTables[filterItemTableID] !== undefined) {
            storeTableCheckboxes(filterItemTableID);
            allTables[filterItemTableID].init();
            reInitCheckboxes();
          }
          if ($("#" + filterItemTableID).hasClass("ajax-sort-table")) {
            checkTableCheckboxes(filterItemTableID);
          }
          $("#" + filterItemTableID).slideDown();
        }

        // Update active filters count
        if (activeFiltersCount.length > 0) {
          var allFilters = filterForm.find(
            '#filterPanel select, #filterPanel input[type="text"], #filterPanel input[type="date"], .status-filter-input'
          );

          var activeFilters = Array.from(allFilters).filter((el) => {
            if (el.tagName === "SELECT") {
              return el.value !== "";
            } else if (el.tagName === "INPUT") {
              return el.value !== "";
            }
            return false;
          });

          activeFiltersCount.html(activeFilters.length);
          if (activeFilters.length == 0) {
            activeFiltersCount.addClass("d-none");
            if (resetButton !== undefined) {
              resetButton.addClass("d-none");
            }
          } else {
            activeFiltersCount.removeClass("d-none");
            if (resetButton !== undefined) {
              resetButton.removeClass("d-none");
            }
          }
        }

        if (response.data.csv !== undefined) {
          var fileNameCSV = "export.csv";
          if (currentInput.data("file-name") !== undefined) {
            fileNameCSV = currentInput.data("file-name");
          }

          currentCSVData += response.data.csv;
          offset = response.data.next_offset;

          if (response.data.has_more) {
            batchProcessCSV(currentButton, form_data, nonce, offset, fileNameCSV);
          } else {
            finishExport(currentButton, fileNameCSV, currentCSVData);
          }
        }

        if (response.data.pdf !== undefined) {
          var downloadLink = document.createElement("a");
          var fileData = [response.data.pdf];

          var blobObject = new Blob(fileData, {
            type: "application/pdf",
          });

          var url = URL.createObjectURL(blobObject);
          downloadLink.href = url;
          downloadLink.download = "export.pdf";
          if (currentInput.data("file-name") !== undefined) {
            downloadLink.download = currentInput.data("file-name");
          }

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
      },
      error: function (data) {
        console.log("[main.js handleFilterFormEvent] error: ", data);
      },
    });
    return false;
  };

  $("body").on(
    "change click",
    '.filter-form :input:not(:checkbox, .dropdown-toggle, .no-filter, .ignore-filter-action, .multi-select-action, .multi-do-action, .filter-status-button, .info-button, [name="search_date"], [type="date"]), .filter-form .dataTable-sorter, .filter-form .delete-debtor, .btn-export-filter-table',
    handleFilterFormEvent
  );

  $(".filter-form	").on("keypress", function (e) {
    if (e.which == 13) {
      $(this).find(".filter-button").trigger("click");
      return false;
    }
  });

  $("[data-trigger-filter-form]").on("click", function () {
    let filterFormID = $(this).data("trigger-filter-form");
    console.log("[main.js] filterFormID: ", filterFormID);
    let filterForm = $("#" + filterFormID);
    filterForm.find(".filter-button").trigger("click");
  });

  function getFilterFormFormData(filterForm, currentInput) {
    let form_data = {};
    let form = filterForm.serializeArray();
    let formID = filterForm.attr("id");

    for (var i = 0; i < form.length; i++) {
      if (form[i]["name"].endsWith("[]")) {
        var name = form[i]["name"];
        name = name.substring(0, name.length - 2);
        if (!(name in form_data)) {
          form_data[name] = [];
        }
        form_data[name].push(form[i]["value"]);
      } else {
        form_data[form[i]["name"]] = form[i]["value"];
      }
    }

    if (allFilterData[formID] != undefined) {
      for (const property in allFilterData[formID]) {
        console.log("[main.js getFilterFormFormData] " + property + ": " + allFilterData[formID][property]);
        for (const filterItem in allFilterData[formID][property]) {
          form_data[filterItem] = allFilterData[formID][property][filterItem];
        }
      }
    }

    let thActive = filterForm.find("th.active");
    let currentOrderBy = thActive.data("order-by");
    let currentSortOrder = thActive.hasClass("desc") ? "DESC" : "ASC";
    let currentOrderType = thActive.data("order-type");

    if (currentOrderBy != undefined) {
      form_data["orderby"] = currentOrderBy;
      form_data["order"] = currentSortOrder;
    }

    if (currentOrderType != undefined) {
      form_data["ordertype"] = currentOrderType;
    }

    if (currentInput !== undefined && currentInput.hasClass("pager-link")) {
      form_data["paged"] = currentInput.data("page");
      console.log("[main.js getFilterFormFormData] paged: ", currentInput.data("page"));
    } else if (filterForm.find(".pager.active")) {
      form_data["paged"] = filterForm.find(".pager.active button").data("page");
      console.log("[main.js getFilterFormFormData] paged: ", currentInput.data("page"));
    }
    if (currentInput.is(".form-control, .form-select, .reset-button")) {
      form_data["paged"] = 1;
      console.log("[main.js getFilterFormFormData] paged: ", 1);
    }

    if (currentInput !== undefined && currentInput.hasClass("btn-export-filter-table")) {
      if (currentInput.attr("data-file-type") === "csv") {
        form_data["export_csv"] = "true";
        let tableHead = filterForm.find("thead").html();
        form_data["table_head"] = JSON.stringify(tableHead);
        form_data["offset"] = 0;
        console.log("[main.js getFilterFormFormData] currentInput: export_csv");
      }
      if (currentInput.attr("data-file-type") === "pdf") {
        form_data["export_pdf"] = "true";
        console.log("[main.js getFilterFormFormData] currentInput: export_pdf");
      }
      if (currentInput.attr("data-export-type") !== undefined) {
        form_data["export_type"] = currentInput.data("export-type");
        console.log("[main.js getFilterFormFormData] currentInput export_type: ", currentInput.data("export-type"));
      }
    }

    return form_data;
  }

  function batchProcessCSV(currentButton, formData, nonce, offset, fileNameCSV) {
    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "filter_items",
        nonce: nonce,
        offset: offset,
        form_data: formData,
      },
      success: function (response) {
        if (response.success) {
          currentCSVData += response.data.csv;
          offset = response.data.next_offset;
          // Process the next batch if there is one
          if (response.data.has_more) {
            batchProcessCSV(currentButton, formData, nonce, offset, fileNameCSV);
            updateProgressBar(modalProgressBar, offset, response.data.total_batches - 1);
          } else {
            finishExport(currentButton, fileNameCSV, currentCSVData);
          }
        } else {
          console.error("Error during CSV generation:", response.data);
        }
      },
    });
  }

  function finishExport(button, filename, csvData) {
    console.log("CSV generation completed.");
    setProgressBar(modalProgressBar, "100", "Export abgeschlossen.");
    downloadCSV(csvData, filename);
    setTimeout(function () {
      progressModal.modal("hide");
      // Reset variables for next export
      currentCSVData = "";
      setProgressBar(modalProgressBar, "0", "");
      btnReset(button);
    }, 1000);
  }

  function downloadCSV(data, filename) {
    const blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename || "export.csv";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }

  /**
   * Call the main download file function.
   */
  $(document).on("click", ".download-file-button", function (event) {
    event.preventDefault();
    let currentButton = $(this);
    let parentModal = currentButton.parents(".modal");
    let itemID = currentButton.data("item-id");
    let itemType = currentButton.data("item-type");
    let reloadURL = currentButton.data("reload-url");
    let nonce = $("#download_file_nonce").val();
    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "download_file",
        nonce: nonce,
        item_id: itemID,
        item_type: itemType,
      },
      success: function (response) {
        if (response.success === true) {
          console.log("response: ", response);
          if (response.data.csv !== undefined) {
            var downloadLink = document.createElement("a");
            var fileData = ["\ufeff" + response.data.csv];

            var blobObject = new Blob(fileData, {
              type: "text/csv;charset=utf-8;",
            });

            var url = URL.createObjectURL(blobObject);
            downloadLink.href = url;
            downloadLink.download = "export.csv";
            if (currentButton.data("file-name") !== undefined) {
              downloadLink.download = currentButton.data("file-name");
            }

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          }
          if (parentModal !== undefined) {
            parentModal.modal("hide");
          }
          if (reloadURL !== undefined) {
            location.replace(reloadURL);
          }
        } else {
          console.log("error: ", response);
        }
      },
    });
    return false;
  });

  /**
   * Modifies the .info-modal modals.
   */
  $(".info-modal").on("show.bs.modal", function (event) {
    var modal = $(this);
    var button = $(event.relatedTarget);
    var itemID = button.data("item-id");
    var itemType = button.data("item-type");
    var noItemText = button.data("no-item-text");
    var modalTitle = button.data("modal-title");
    var modalItemName = button.data("modal-item-name");
    var reloadURL = button.data("reload-url");
    var filterFormID = button.attr("data-filter-form-id");
    var modalInfo = modal.find(".modal-info");
    var actionButton = modal.find(".main-action-button");
    let nonce = $("#get_item_info_nonce").val();

    if (itemID !== undefined) {
      actionButton.attr("data-item-id", itemID);
      console.log("itemID: " + itemID);
    }
    if (itemType !== undefined) {
      actionButton.attr("data-item-type", itemType);
      console.log("itemType: " + itemType);
    }
    if (noItemText !== undefined) {
      actionButton.attr("data-no-item-text", noItemText);
      console.log("noItemText: " + noItemText);
    }
    if (modalTitle !== undefined) {
      modal.find(".modal-title").html(modalTitle);
    }
    if (modalItemName !== undefined) {
      modal.find(".modal-item-name").text(modalItemName);
    }
    if (reloadURL !== undefined) {
      actionButton.attr("data-reload-url", reloadURL);
      console.log("reloadURL: " + reloadURL);
    }
    if (filterFormID !== undefined) {
      actionButton.attr("data-filter-form-id", filterFormID);
      console.log("filterFormID: " + filterFormID);
    }

    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "get_item_info",
        nonce: nonce,
        item_id: itemID,
        item_type: itemType,
      },
      beforeSend: function (xhr) {
        modalInfo.slideUp();
        $(loadingHTML).insertAfter(modalInfo);
      },
      success: function (data) {
        $("#loading-html").remove();
        modalInfo.html(data);
        modalInfo.slideDown();
        if (itemType == "order_items_credit_statement") {
          console.log("attachEventListenersForCreditCalculation");
          attachEventListenersForCreditCalculation();
          setOrderCredtitButtonIds(itemID);
        }
      },
      error: function (data) {
        console.log(data);
      },
    });
  });

  function attachEventListenersForCreditCalculation() {
    console.log("attaching event listeners for credit calculation...");
    $(".credit-item-input").on("change", function () {
      console.log("calculating credit sum...");
      calculateCreditSum();
    });
  }

  // Function to calculate the total credit sum
  function calculateCreditSum() {
    let totalSum = 0;

    // Restock checkbox
    if (totalSum > 0) {
      $("#restock_refunded_items").closest("tr").show();
    } else {
      $("#restock_refunded_items").closest("tr").hide();
    }

    $(".credit-item-input").each(function () {
      let quantity = parseFloat($(this).val());
      let price = parseFloat($(this).data("price"));

      if (!isNaN(quantity) && !isNaN(price)) {
        totalSum += quantity * price;
      }
      if ($(this).val() > 0) {
        $("#restock_refunded_items").closest("tr").show();
      }
    });

    $("#credit-sum").text(totalSum.toFixed(2));
  }

  function setOrderCredtitButtonIds(orderID) {
    // get current url
    let url = window.location.href + "/rechnung-herunterladen/" + orderID + '/?credit_memo=true"';
    // add /rechnung-herunterladen/{{ order.get_id }}/?credit_memo=true"
  }

  $(document).on("click", ".download-invoice-button", function () {
    let currentInput = $(this);
    let filterForm = $(this).parents(".filter-form");

    if (filterForm !== undefined) {
      setTimeout(function () {
        $(filterForm).find(".filter-button").trigger("click");
        return false;
      }, 500);
    }
  });

  $(document).on("click", ".main-delete-items-button", function () {
    let items = [];
    let currentButton = $(this);
    let parentModal = $(this).parents(".modal");
    let itemID = $(this).data("item-id");
    let itemIDs = $(this).data("item-ids");
    let reloadURL = $(this).data("reload-url");
    let itemType = $(this).data("item-type");
    let itemsContainer = $(this).data("items-container");
    let itemsTableID = $(this).data("items-table");
    let nonce = $("#delete_items_nonce").val();

    let URLString = "";

    if (itemID !== undefined && itemID !== "") {
      items.push(itemID);
      URLString = "?deleted=true";
    } else if (itemIDs !== undefined) {
      items = itemIDs.split(",");
      URLString = "?deleted_multiple=true";
    }
    var itemsLength = items.length;

    console.log("items: ", items);
    console.log("itemType: ", itemType);

    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "delete_items",
        nonce: nonce,
        items: items,
        item_type: itemType,
      },
      beforeSend: function (xhr) {
        btnDeleting(currentButton);
        if (itemsTableID !== "") {
          console.log("itemsTableID: ", itemsTableID);
          $("#" + itemsTableID).slideUp();
          allTables[itemsTableID].destroy();
          $(loadingHTML).insertAfter("#" + itemsTableID);
        }
      },
      success: function (data) {
        console.log("success: ", data);
        btnReset(currentButton);
        if (data.success_msg) {
          console.log("success: ", data.success_msg);
        } else {
          $("#loading-html").remove();
          if (itemsContainer !== "") {
            $("#" + itemsContainer).html(data);
          }
          if (itemsTableID !== "") {
            storeTableCheckboxes(itemsTableID);
            allTables[itemsTableID].init();
            $("#" + itemsTableID).slideDown();
          }

          reInitCheckboxes();
        }

        setTimeout(function () {
          parentModal.modal("hide");

          if (reloadURL !== undefined) {
            //console.log('reloadURL: '+ reloadURL + URLString);
            location.replace(reloadURL + URLString);
          }
        }, 1000);
      },
      error: function (data) {
        console.log(data);
      },
    });
    return false;
  });

  /**
   * Changes the target modal of .multi-do-action button
   */
  $(".multi-select-action").change(function () {
    var selectedOption = $(this).find(":selected");
    var actionButton = $(this).next(".multi-do-action");

    var modalID = selectedOption.data("modal-change");
    var modalTitle = selectedOption.data("modal-title");
    var modalItemName = selectedOption.data("modal-item-name");
    var modalReloadURL = selectedOption.data("reload-url");

    if (modalID !== undefined) {
      actionButton.attr("data-bs-target", "#" + modalID);
    }
    if (modalTitle !== undefined) {
      actionButton.attr("data-modal-title", modalTitle);
    }
    if (modalItemName !== undefined) {
      actionButton.attr("data-modal-item-name", modalItemName);
    }
    if (modalReloadURL !== undefined) {
      actionButton.attr("data-reload-url", modalReloadURL);
    }
  });

  $(".multi-do-action").click(function (e) {
    e.preventDefault();
  });

  /**
   * Modifies the .main-modal modals.
   */
  $(".main-modal").on("show.bs.modal", function (event) {
    var modal = $(this);
    var button = $(event.relatedTarget);
    var itemID = button.data("item-id");
    var itemType = button.data("item-type");
    var itemIndex = button.data("item-index");
    var itemStatus = button.data("item-status");
    var noItemText = button.data("no-item-text");
    var modalTitle = button.data("modal-title");
    var modalItemName = button.data("modal-item-name");
    var reloadURL = button.data("reload-url");
    var filterFormID = button.attr("data-filter-form-id");
    var checkItemsWrap = button.data("check-items-wrap");
    var actionButton = modal.find(".main-action-button");

    if (itemID !== undefined) {
      actionButton.attr("data-item-id", itemID);
      console.log("itemID: " + itemID);
    }
    if (itemType !== undefined) {
      actionButton.attr("data-item-type", itemType);
      console.log("itemType: " + itemType);
    }
    if (itemIndex !== undefined) {
      actionButton.attr("data-item-index", itemIndex);
      console.log("itemIndex: " + itemIndex);
    }
    if (itemStatus !== undefined) {
      actionButton.attr("data-item-status", itemStatus);
      modal.find(".modal-item-status").val(itemStatus);
      console.log("itemStatus: " + itemStatus);
    }
    if (noItemText !== undefined) {
      actionButton.attr("data-no-item-text", noItemText);
      console.log("noItemText: " + noItemText);
    }
    if (reloadURL !== undefined) {
      actionButton.attr("data-reload-url", reloadURL);
      console.log("reloadURL: " + reloadURL);
    }
    if (filterFormID !== undefined) {
      actionButton.attr("data-filter-form-id", filterFormID);
      console.log("filterFormID: " + filterFormID);
    }
    if (modalTitle !== undefined) {
      modal.find(".modal-title").html(modalTitle);
    }
    if (modalItemName !== undefined) {
      modal.find(".modal-item-name").html(modalItemName);
    }
    if (checkItemsWrap !== undefined) {
      var selectedIDs = [];
      var ul = $("<ul>", { class: "item-ul m-0" });
      $(modal.find(".item-ul")).remove();
      if (allTablesCheckboxes[checkItemsWrap] !== undefined) {
        for (key in allTablesCheckboxes[checkItemsWrap]) {
          if (allTablesCheckboxes[checkItemsWrap][key]["checked"]) {
            var id = allTablesCheckboxes[checkItemsWrap][key]["id"];
            var name = allTablesCheckboxes[checkItemsWrap][key]["name"];
            var li = $("<li>").attr("data-item-id", id).html(name);
            // Grab all other data attributes from the checkbox and add them to the li
            Object.entries(allTablesCheckboxes[checkItemsWrap][key]).forEach(([key, value]) => {
              if (key !== "id" && key !== "name" && key !== "checked") {
                li.attr("data-" + key, value);
              }
            });
            selectedIDs.push(id);
            ul.append(li);
          }
        }
      } else {
        $("#" + checkItemsWrap)
          .find("input:checked:not(.table-check-toggler)")
          .each(function () {
            var id = $(this).data("id");
            var name = $(this).data("name");
            var li = $("<li>").attr("data-item-id", id).html(name);
            // Grab all other data attributes from the checkbox and add them to the li
            Object.entries($(this).data()).forEach(([key, value]) => {
              if (key !== "id" && key !== "name" && key !== "checked") {
                li.attr("data-" + key, value);
              }
            });
            selectedIDs.push(id);
            ul.append(li);
          });
      }
      console.log("selectedIDs: ", selectedIDs);
      if (selectedIDs.length === 0) {
        actionButton.addClass("d-none");
        if (noItemText !== undefined) {
          modal.find(".modal-info").addClass("d-none");
          //modal.find('.modal-item-name').html('<i class="fa fa-exclamation-triangle me-1"></i>' + noItemText);
          let noItemHtml =
            '<div class="alert alert-warning d-flex align-items-center modal-no-item-info"><i class="fa fa-exclamation-triangle me-1"></i>' +
            noItemText +
            "</div>";
          $(noItemHtml).insertAfter(modal.find(".modal-info"));
        }
        modal.find(".modal-form").addClass("d-none");
      } else {
        actionButton.removeClass("d-none");
        modal.find(".modal-info").removeClass("d-none");
        $(modal.find(".modal-no-item-info")).remove();
        modal.find(".modal-form").removeClass("d-none");
        if (selectedIDs.length === 1) {
          actionButton.attr("data-item-id", selectedIDs);
        } else {
          actionButton.attr("data-item-ids", selectedIDs);
        }
      }

      modal.find(".item-list").append(ul);
    }
  });

  /**
   * Call the main delete post function.
   */
  $(document).on("click", "#main-delete-post-button", function () {
    let deleteItems = [];
    let parentModal = $(this).parents(".modal");
    let deleteItemID = $(this).data("item-id");
    let deleteItemIDs = $(this).data("item-ids");
    let itemType = $(this).data("item-type");
    let reloadURL = $(this).data("reload-url");
    let nonce = $("#delete_post_nonce").val();
    let URLString = "";

    if (deleteItemID !== undefined && deleteItemID !== "") {
      deleteItems.push(deleteItemID);
      URLString = "/?deleted=true";
    } else if (deleteItemIDs !== undefined) {
      deleteItems = deleteItemIDs.split(",");
      URLString = "/?deleted_multiple=true";
    }
    var deleteItemsLength = deleteItems.length;
    var i = 0;

    console.log("deleteItems: ", deleteItems);

    function process(i) {
      console.log("deleteItems[i]: ", deleteItems[i]);
      $.post(ajax_url, {
        action: "delete_post",
        delete_post_nonce: nonce,
        current_post_id: deleteItems[i],
        current_post_type: itemType,
      }).done(function (result) {
        if (result.success === true) {
          //console.log('result: ', result);
          console.log("success_msg: " + result.data.success_msg);
          //console.log('deletedItems: ' + i);

          $('  <span class="text-success">  <i class="fa fa-check-circle"></i> Gelöscht</span>').appendTo(
            parentModal.find($("li[data-item-id='" + deleteItems[i] + "']"))
          );

          if (i === deleteItems.length - 1) {
            parentModal.find(".modal-info").removeClass("alert-info").addClass("alert-success");

            setTimeout(function () {
              parentModal.modal("hide");

              if (reloadURL !== undefined) {
                location.replace(reloadURL + URLString);
              } else {
                location.reload(true);
              }
            }, 2000);
          }
        } else {
          console.log("error: ", result);
          $('<span class="text-danger">  <i class="fa fa-times-circle"></i> Fehler</span>').appendTo(
            parentModal.find($("li[data-item-id='" + deleteItems[i] + "']"))
          );
        }
        if (i++ < deleteItems.length - 1) {
          process(i);
        }
      });
    }

    process(0);
    return false;
  });

  /**
   * Modifies the main delete term modal.
   */
  $("#modal-delete-term").on("show.bs.modal", function (event) {
    var button = $(event.relatedTarget);
    var deleteTermID = button.data("delete-term-id");
    var deleteTermTaxonomy = button.data("delete-term-taxonomy");
    var deleteTermChildren = button.data("delete-term-children");
    var modalTitle = button.data("modal-title");
    var deleteTermName = button.data("delete-term-name");
    var reloadURL = button.data("reload-url");

    var modal = $(this);
    if (deleteTermID !== undefined) {
      $("#main-delete-term-button").attr("data-delete-term-id", deleteTermID);
      console.log("deleteTermID: " + deleteTermID);
    }
    if (deleteTermTaxonomy !== undefined) {
      $("#main-delete-term-button").attr("data-delete-term-taxonomy", deleteTermTaxonomy);
      console.log("deleteTermTaxonomy: " + deleteTermTaxonomy);
    }
    if (deleteTermChildren !== undefined) {
      $("#main-delete-term-button").attr("data-delete-term-children", deleteTermChildren);
      console.log("deleteTermChildren: " + deleteTermChildren);
    }
    if (reloadURL !== undefined) {
      $("#main-delete-term-button").attr("data-reload-url", reloadURL);
      console.log("reloadURL: " + reloadURL);
    }
    if (modalTitle !== undefined) {
      modal.find(".modal-title").text(modalTitle);
    }
    if (deleteTermName !== undefined) {
      modal.find("#delete-term-name").text(deleteTermName);
    }
  });

  /**
   * Call the main delete term function.
   */
  $(document).on("click", "#main-delete-term-button", function () {
    let parentModal = $(this).parents(".modal");
    let deleteTermID = $(this).data("delete-term-id");
    let deleteTermTaxonomy = $(this).data("delete-term-taxonomy");
    let deleteTermChildren = $(this).data("delete-term-children");
    let reloadURL = $(this).data("reload-url");
    let nonce = $("#delete_term_nonce").val();
    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "delete_term",
        delete_term_nonce: nonce,
        current_term_id: deleteTermID,
        current_term_taxonomy: deleteTermTaxonomy,
        current_term_delete_children: deleteTermChildren,
      },
      success: function (result) {
        if (result.success === true) {
          console.log("result: ", result);
          console.log("success_msg: " + result.data.success_msg);
          parentModal.modal("hide");

          if (reloadURL !== undefined) {
            location.replace(reloadURL + "/?deleted=true");
          } else {
            location.reload(true);
          }
        } else {
          console.log("error: ", result);
        }
      },
    });
    return false;
  });

  /**
   * Modifies the main delete file modal.
   */
  $("#modal-delete-file").on("show.bs.modal", function (event) {
    var button = $(event.relatedTarget);
    var deleteFileID = button.data("delete-file-id");
    var modalTitle = button.data("modal-title");
    var deleteFileName = button.data("delete-file-name");
    var reloadURL = button.data("reload-url");

    var modal = $(this);
    if (deleteFileID !== undefined) {
      $("#main-delete-file-button").attr("data-delete-file-id", deleteFileID);
      console.log("deleteFileID: " + deleteFileID);
    }
    if (reloadURL !== undefined) {
      $("#main-delete-file-button").attr("data-reload-url", reloadURL);
      console.log("reloadURL: " + reloadURL);
    }
    if (modalTitle !== undefined) {
      modal.find(".modal-title").text(modalTitle);
    }
    if (deleteFileName !== undefined) {
      modal.find("#delete-file-name").text(deleteFileName);
    }
  });

  /**
   * Call the main delete file function.
   */
  $(document).on("click", "#main-delete-file-button", function () {
    let parentModal = $(this).parents(".modal");
    let deleteFileID = $(this).data("delete-file-id");
    let reloadURL = $(this).data("reload-url");
    let nonce = $("#delete_file_nonce").val();
    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "delete_file",
        delete_file_nonce: nonce,
        current_file_id: deleteFileID,
      },
      success: function (result) {
        if (result.success === true) {
          console.log("result: ", result);
          console.log("success_msg: " + result.data.success_msg);
          parentModal.modal("hide");

          if (reloadURL !== undefined) {
            location.replace(reloadURL + "/?deleted=true");
          } else {
            location.reload(true);
          }
        } else {
          console.log("error: ", result);
        }
      },
    });
    return false;
  });

  /**
   * Call the main delete user function.
   */
  $(document).on("click", "#main-delete-user-button", function () {
    let deleteItems = [];
    let parentModal = $(this).parents(".modal");
    let deleteItemID = $(this).data("item-id");
    let deleteItemIDs = $(this).data("item-ids");
    let reloadURL = $(this).data("reload-url");
    let nonce = $("#delete_user_nonce").val();
    let URLString = "";

    if (deleteItemID !== undefined && deleteItemID !== "") {
      deleteItems.push(deleteItemID);
      URLString = "/?deleted=true";
    } else if (deleteItemIDs !== undefined) {
      deleteItems = deleteItemIDs.split(",");
      URLString = "/?deleted_multiple=true";
    }
    var deleteItemsLength = deleteItems.length;
    var i = 0;

    console.log("deleteItems: ", deleteItems);

    function process(i) {
      console.log("deleteItems[i]: ", deleteItems[i]);
      $.post(ajax_url, {
        action: "delete_user",
        delete_user_nonce: nonce,
        current_user_id: deleteItems[i],
      }).done(function (result) {
        if (result.success === true) {
          //console.log('result: ', result);
          console.log("success_msg: " + result.data.success_msg);
          //console.log('deletedItems: ' + i);

          $('  <span class="text-success">  <i class="fa fa-check-circle"></i> Gelöscht</span>').appendTo(
            parentModal.find($("li[data-item-id='" + deleteItems[i] + "']"))
          );

          if (i === deleteItems.length - 1) {
            parentModal.find(".modal-info").removeClass("alert-info").addClass("alert-success");

            setTimeout(function () {
              parentModal.modal("hide");

              if (reloadURL !== undefined) {
                location.replace(reloadURL + URLString);
              } else {
                location.reload(true);
              }
            }, 2000);
          }
        } else {
          console.log("error: ", result);
          $('<span class="text-danger">  <i class="fa fa-times-circle"></i> Fehler</span>').appendTo(
            parentModal.find($("li[data-item-id='" + deleteItems[i] + "']"))
          );
        }
        if (i++ < deleteItems.length - 1) {
          process(i);
        }
      });
    }

    process(0);
    return false;
  });

  /**
   * Modifies the main edit term modal.
   */
  $("#modal-edit-term").on("show.bs.modal", function (event) {
    var button = $(event.relatedTarget);
    var editTermID = button.data("edit-term-id");
    var editTermTaxonomy = button.data("edit-term-taxonomy");
    var modalTitle = button.data("modal-title");
    var editTermName = button.data("edit-term-name");
    var editTermDesc = button.data("edit-term-desc");
    var editTermNum = button.data("edit-term-num");
    var reloadURL = button.data("reload-url");

    var modal = $(this);
    if (editTermID !== undefined) {
      $("#main-edit-term-button").attr("data-edit-term-id", editTermID);
      console.log("editTermID: " + editTermID);
    }
    if (editTermTaxonomy !== undefined) {
      $("#main-edit-term-button").attr("data-edit-term-taxonomy", editTermTaxonomy);
      console.log("editTermTaxonomy: " + editTermTaxonomy);
    }
    if (reloadURL !== undefined) {
      $("#main-edit-term-button").attr("data-reload-url", reloadURL);
      console.log("reloadURL: " + reloadURL);
    }
    if (modalTitle !== undefined) {
      modal.find(".modal-title").text(modalTitle);
    }
    if (editTermName !== undefined) {
      modal.find("#edit-term-name").val(editTermName);
    }
    if (editTermDesc !== undefined) {
      modal.find("#edit-term-desc-row").removeClass("d-none");
      modal.find("#edit-term-desc").val(editTermDesc);
    } else {
      modal.find("#edit-term-desc-row").addClass("d-none");
    }
    if (editTermNum !== undefined) {
      modal.find("#edit-term-num-row").removeClass("d-none");
      modal.find("#edit-term-num").val(editTermNum);
    } else {
      modal.find("#edit-term-num-row").addClass("d-none");
    }
  });

  /**
   * Call the main edit term function.
   */
  $(document).on("click", "#main-edit-term-button", function () {
    let parentModal = $(this).parents(".modal");
    let editTermID = $(this).data("edit-term-id");
    let editTermTaxonomy = $(this).data("edit-term-taxonomy");
    let reloadURL = $(this).data("reload-url");
    let nonce = $("#edit_term_nonce").val();
    let editTermName = parentModal.find("#edit-term-name").val();
    let editTermDesc = parentModal.find("#edit-term-desc").val();
    let editTermNum = parentModal.find("#edit-term-num").val();
    console.log("editTermName: " + editTermName);

    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "edit_term",
        edit_term_nonce: nonce,
        current_term_id: editTermID,
        current_term_taxonomy: editTermTaxonomy,
        current_term_edit_name: editTermName,
        current_term_edit_desc: editTermDesc,
        current_term_edit_num: editTermNum,
      },
      success: function (result) {
        if (result.success === true) {
          console.log("result: ", result);
          console.log("success_msg: " + result.data.success_msg);
          parentModal.modal("hide");

          if (reloadURL !== undefined) {
            location.replace(reloadURL + "/?edited=true");
          } else {
            location.reload(true);
          }
        } else {
          console.log("error: ", result);
        }
      },
    });
    return false;
  });

  /**
   * Modifies the main duplicate term modal.
   */
  $("#modal-duplicate-term").on("show.bs.modal", function (event) {
    var button = $(event.relatedTarget);
    var duplicateTermID = button.data("duplicate-term-id");
    var duplicateTermTaxonomy = button.data("duplicate-term-taxonomy");
    var duplicateTermChildren = button.data("duplicate-term-children");
    var modalTitle = button.data("modal-title");
    var duplicateTermName = button.data("duplicate-term-name");
    var reloadURL = button.data("reload-url");

    var modal = $(this);
    if (duplicateTermID !== undefined) {
      $("#main-duplicate-term-button").attr("data-duplicate-term-id", duplicateTermID);
      console.log("duplicateTermID: " + duplicateTermID);
    }
    if (duplicateTermTaxonomy !== undefined) {
      $("#main-duplicate-term-button").attr("data-duplicate-term-taxonomy", duplicateTermTaxonomy);
      console.log("duplicateTermTaxonomy: " + duplicateTermTaxonomy);
    }
    if (duplicateTermChildren !== undefined) {
      $("#main-duplicate-term-button").attr("data-duplicate-term-children", duplicateTermChildren);
      console.log("duplicateTermChildren: " + duplicateTermChildren);
    }
    if (reloadURL !== undefined) {
      $("#main-duplicate-term-button").attr("data-reload-url", reloadURL);
      console.log("reloadURL: " + reloadURL);
    }
    if (modalTitle !== undefined) {
      modal.find(".modal-title").text(modalTitle);
    }
    if (duplicateTermName !== undefined) {
      modal.find("#duplicate-term-name").val(duplicateTermName + " [Duplikat]");
    }
  });

  /**
   * Call the main duplicate term function.
   */
  $(document).on("click", "#main-duplicate-term-button", function () {
    let parentModal = $(this).parents(".modal");
    let duplicateTermID = $(this).data("duplicate-term-id");
    let duplicateTermTaxonomy = $(this).data("duplicate-term-taxonomy");
    let duplicateTermChildren = $(this).data("duplicate-term-children");
    let reloadURL = $(this).data("reload-url");
    let nonce = $("#duplicate_term_nonce").val();
    let duplicateTermName = parentModal.find("#duplicate-term-name").val();
    console.log("duplicateTermName: " + duplicateTermName);

    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "duplicate_term",
        duplicate_term_nonce: nonce,
        current_term_id: duplicateTermID,
        current_term_taxonomy: duplicateTermTaxonomy,
        current_term_duplicate_children: duplicateTermChildren,
        current_term_duplicate_name: duplicateTermName,
      },
      success: function (result) {
        if (result.success === true) {
          console.log("result: ", result);
          console.log("success_msg: " + result.data.success_msg);
          parentModal.modal("hide");

          if (reloadURL !== undefined) {
            location.replace(reloadURL + "/?duplicated=true");
          } else {
            location.reload(true);
          }
        } else {
          console.log("error: ", result);
        }
      },
    });
    return false;
  });

  /**
   * Call the main duplicate post function.
   */
  $(document).on("click", ".duplicate-post-button", function () {
    let duplicatePostID = $(this).data("duplicate-post-id");
    let duplicatePostType = $(this).data("duplicate-post-type");
    let reloadURL = $(this).data("reload-url");
    let nonce = $("#duplicate_post_nonce").val();

    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "duplicate_post",
        duplicate_post_nonce: nonce,
        current_post_id: duplicatePostID,
        post: duplicatePostID,
        current_post_type: duplicatePostType,
      },
      success: function (result) {
        if (result.success === true) {
          console.log("result: ", result);
          console.log("success_msg: " + result.data.success_msg);

          if (reloadURL !== undefined) {
            location.replace(reloadURL + "/?duplicated=true");
          } else {
            location.reload(true);
          }
        } else {
          console.log("error: ", result);
        }
      },
      error: function (err) {
        console.log(err);
      },
    });
    return false;
  });

  /**
   * Call the main send mail function.
   */
  $(document).on("click", "#main-send-mail-button", function () {
    let sendItems = [];
    let currentButton = $(this);
    let parentModal = $(this).parents(".modal");
    let sendItemID = $(this).data("item-id");
    let sendItemIDs = $(this).data("item-ids");
    let reloadURL = $(this).data("reload-url");
    let nonce = $("#send_mail_nonce").val();
    let sendMailSubject = $("#send-mail-subject").val();
    //let sendMailContent = $('#send_mail_content').html();
    let sendMailContent = tinymce.get("send_mail_content").getContent();
    let URLString = "";

    if (sendItemID !== undefined && sendItemID !== "") {
      sendItems.push(sendItemID);
      URLString = "/?sended=true";
    } else if (sendItemIDs !== undefined) {
      sendItems = sendItemIDs.split(",");
      URLString = "/?sended_multiple=true";
    }
    var sendItemsLength = sendItems.length;
    var i = 0;

    console.log("sendItems: ", sendItems);

    btnSending(currentButton);

    function process(i) {
      console.log("sendItems[i]: ", sendItems[i]);
      $.post(ajax_url, {
        action: "send_mail",
        send_mail_nonce: nonce,
        send_mail_subject: sendMailSubject,
        send_mail_content: sendMailContent,
        current_recipient_id: sendItems[i],
        email_attachment_ids: $("#email-attachment-ids").val(),
      }).done(function (result) {
        if (result.success === true) {
          //console.log('result: ', result);
          console.log("success_msg: " + result.data.success_msg);
          //console.log('senddItems: ' + i);

          $('  <span class="text-success">  <i class="fa fa-check-circle"></i> gesendet</span>').appendTo(
            parentModal.find($("li[data-item-id='" + sendItems[i] + "']"))
          );
        } else {
          console.log("error: ", result);
          var errorMSG = "";
          if (result.data.error_msg !== "") {
            errorMSG = result.data.error_msg;
          }
          $('<span class="text-danger">  <i class="fa fa-times-circle"></i> Fehler' + errorMSG + "</span>").appendTo(
            parentModal.find($("li[data-item-id='" + sendItems[i] + "']"))
          );
        }

        if (i === sendItems.length - 1) {
          btnReset(currentButton);
          parentModal.find(".modal-info").removeClass("alert-info").addClass("alert-success");

          setTimeout(function () {
            parentModal.modal("hide");

            if (reloadURL !== undefined) {
              location.replace(reloadURL + URLString);
            } else {
              //location.reload(true);
            }
          }, 2000);
        }
        if (i++ < sendItems.length - 1) {
          process(i);
        }
      });
    }

    process(0);
    return false;
  });

  // Handle email resend
  $(document).on("click", ".resend-email", function (e) {
    e.preventDefault();
    const emailLogId = $(this).data("email-log-id");
    const $button = $(this);

    // Disable button and show loading state
    $button.prop("disabled", true);
    $button.html('<i class="fa fa-spinner fa-spin me-2"></i>Wird gesendet...');

    // Send AJAX request to resend email
    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "retry_failed_email",
        email_log_id: emailLogId,
        nonce: jeckplan_ajax.nonce,
      },
      success: function (response) {
        if (response.success) {
          // Show success message
          allNotifications["notyf"].open({
            type: "success",
            message: "E-Mail wurde erfolgreich erneut gesendet.",
          });
          // Reload the page after a short delay to show updated status
          setTimeout(function () {
            window.location.reload();
          }, 1500);
        } else {
          // Show error message
          allNotifications["notyf"].open({
            type: "danger",
            message: response.data.message || "Fehler beim erneuten Senden der E-Mail",
          });
          // Reset button state
          $button.prop("disabled", false);
          $button.html('<i class="fa fa-paper-plane me-2"></i>E-Mail erneut senden');
        }
      },
      error: function () {
        // Show error message
        allNotifications["notyf"].open({
          type: "danger",
          message: "Ein Fehler ist aufgetreten",
        });
        // Reset button state
        $button.prop("disabled", false);
        $button.html('<i class="fa fa-paper-plane me-2"></i>E-Mail erneut senden');
      },
    });
  });

  // Handle bulk email resend modal
  $("#modal-resend-email").on("shown.bs.modal", function (event) {
    // Get email IDs from the list items already populated in the modal
    const modal = $(this);
    const listItems = modal.find(".item-ul li[data-item-id]");
    let emailIds = [];

    listItems.each(function () {
      const itemId = $(this).data("item-id");
      if (itemId) {
        emailIds.push(parseInt(itemId));
      }
    });

    console.log("shown emailIds from modal list items: ", emailIds);

    if (emailIds.length === 0) {
      allNotifications["notyf"].open({
        type: "danger",
        message: "Keine E-Mails in der Liste gefunden",
      });
      modal.modal("hide");
      return;
    }

    // Check which emails can be resent (in case data changed since modal was populated)
    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "check_emails_resendable",
        email_ids: emailIds,
        nonce: jeckplan_ajax.nonce,
      },
      success: function (response) {
        if (response.success) {
          // Update the modal with fresh resendability data
          populateResendModal(response.data);
        } else {
          allNotifications["notyf"].open({
            type: "danger",
            message: response.data.message || "Fehler beim Prüfen der E-Mails",
          });
        }
      },
      error: function () {
        allNotifications["notyf"].open({
          type: "danger",
          message: "Ein Fehler ist aufgetreten",
        });
      },
    });
  });

  // Populate the resend modal with email information
  function populateResendModal(emails) {
    const modal = $("#modal-resend-email");
    const itemList = modal.find(".item-list");
    const resendButton = $("#main-resend-email-button");

    itemList.empty();

    let resendableCount = 0;
    let totalCount = emails.length;
    const resendableIds = [];
    const allIds = [];

    // Create the list structure that matches the existing modal pattern
    const listContainer = $('<ul class="item-ul m-0"></ul>');

    emails.forEach(function (email) {
      allIds.push(email.id);

      const statusBadge = email.can_resend
        ? '<span class="badge bg-success me-2 align-text-top"><i class="fa fa-check"></i></span>'
        : '<span class="badge bg-warning me-2 align-text-top"><i class="fa fa-exclamation-triangle"></i></span>';

      const listItem = $(`
        <li data-item-id="${email.id}">
          ${statusBadge}
            <span class="fw-bold">${escapeHtml(email.subject || "Kein Betreff")}</span>
            <small class="text-muted">${escapeHtml(email.email_to || "Kein Empfänger")}</small>
        </li>
      `);

      listContainer.append(listItem);

      if (email.can_resend) {
        resendableCount++;
        resendableIds.push(email.id);
      }
    });

    itemList.append(listContainer);

    // Update the modal item name text
    modal.find(".modal-item-name").text(`${totalCount} E-Mail${totalCount !== 1 ? "s" : ""}`);

    // Set the data attributes on the resend button
    if (resendableIds.length === 1) {
      resendButton.attr("data-item-id", resendableIds[0]);
      resendButton.removeAttr("data-item-ids");
    } else if (resendableIds.length > 1) {
      resendButton.attr("data-item-ids", resendableIds.join(","));
      resendButton.removeAttr("data-item-id");
    }

    // Update button text and state
    if (resendableCount === 0) {
      resendButton.prop("disabled", true);
      resendButton.text("Keine E-Mails können erneut gesendet werden");
      resendButton.removeAttr("data-item-id");
      resendButton.removeAttr("data-item-ids");
    } else if (resendableCount === 1) {
      resendButton.prop("disabled", false);
      resendButton.html(`<i class="fa fa-paper-plane me-1"></i>E-Mail erneut senden`);
    } else {
      resendButton.prop("disabled", false);
      resendButton.html(`<i class="fa fa-paper-plane me-1"></i>${resendableCount} E-Mail(s) erneut senden`);
    }
  }

  // Handle bulk resend button click
  $(document).on("click", "#main-resend-email-button", function (e) {
    e.preventDefault();

    const $button = $(this);
    let emailIds = [];

    // Get email IDs from data attributes (following the existing pattern)
    const itemId = $button.data("item-id");
    const itemIds = $button.data("item-ids");

    if (itemId !== undefined && itemId !== "") {
      emailIds.push(itemId);
    } else if (itemIds !== undefined) {
      emailIds = itemIds
        .toString()
        .split(",")
        .map((id) => parseInt(id.trim()));
    }

    if (emailIds.length === 0) {
      allNotifications["notyf"].open({
        type: "danger",
        message: "Keine E-Mails ausgewählt",
      });
      return;
    }

    const originalHtml = $button.html();
    const modal = $("#modal-resend-email");

    // Disable button and show loading state
    $button.prop("disabled", true);
    $button.html('<i class="fa fa-spinner fa-spin me-1"></i>Wird gesendet...');

    // Send bulk resend request
    $.ajax({
      url: ajax_url,
      type: "POST",
      data: {
        action: "resend_multiple_emails",
        email_ids: emailIds,
        nonce: $("#resend_emails_nonce").val(),
      },
      success: function (response) {
        if (response.success) {
          // Update individual items with success/failure status
          if (response.data.results) {
            // Mark successful items
            response.data.results.successful.forEach(function (item) {
              modal
                .find(`li[data-item-id="${item.id}"]`)
                .append('<span class="text-success ms-2"><i class="fa fa-check-circle"></i> gesendet</span>');
            });

            // Mark failed items
            response.data.results.failed.forEach(function (item) {
              modal
                .find(`li[data-item-id="${item.id}"]`)
                .append('<span class="text-danger ms-2"><i class="fa fa-times-circle"></i> Fehler</span>');
            });
          }

          // Update modal info to success state
          modal.find(".modal-info").removeClass("alert-info").addClass("alert-success");

          // Show success message
          allNotifications["notyf"].open({
            type: "success",
            message: response.data.message,
          });

          // Close modal and reload page after showing results
          setTimeout(function () {
            modal.modal("hide");
            setTimeout(function () {
              window.location.reload();
            }, 500);
          }, 2000);
        } else {
          // Show error message
          allNotifications["notyf"].open({
            type: "danger",
            message: response.data.message || "Fehler beim erneuten Senden der E-Mails",
          });

          // Reset button state
          $button.prop("disabled", false);
          $button.html(originalHtml);
        }
      },
      error: function () {
        // Show error message
        allNotifications["notyf"].open({
          type: "danger",
          message: "Ein Fehler ist aufgetreten",
        });

        // Reset button state
        $button.prop("disabled", false);
        $button.html(originalHtml);
      },
    });
  });

  // Utility function to escape HTML
  function escapeHtml(text) {
    const map = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    };
    return text
      ? text.replace(/[&<>"']/g, function (m) {
          return map[m];
        })
      : "";
  }

  /**
   * Call the main edit user function.
   */
  $(document).on("click", "#main-edit-user-button", function () {
    let items = [];
    let currentButton = $(this);
    let parentModal = $(this).parents(".modal");
    let itemID = $(this).data("item-id");
    let itemIDs = $(this).data("item-ids");
    let reloadURL = $(this).data("reload-url");
    let itemType = $(this).data("item-type");
    let nonce = $("#edit_user_nonce").val();
    let modalForm = document.getElementById("modal-form-edit-user");
    let formData = new FormData(modalForm);

    let URLString = "";

    if (itemID !== undefined && itemID !== "") {
      items.push(itemID);
      URLString = "/?edited=true";
    } else if (itemIDs !== undefined) {
      items = itemIDs.split(",");
      URLString = "/?edited_multiple=true";
    }
    var itemsLength = items.length;
    var i = 0;

    console.log("items: ", items);
    console.log("itemType: ", itemType);

    btnSaving(currentButton);

    function process(i) {
      console.log("items[i]: ", items[i]);
      formData.append("action", "edit_user");
      formData.append("edit_user_nonce", nonce);
      formData.append("current_user_id", items[i]);
      formData.append("current_user_role", itemType);
      $.ajax({
        url: ajax_url,
        type: "POST",
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
        success: function (result) {
          if (result.success === true) {
            //console.log('result: ', result);
            console.log("success_msg: " + result.data.success_msg);
            //console.log('editdItems: ' + i);

            $('  <span class="text-success">  <i class="fa fa-check-circle"></i> gespeichert</span>').appendTo(
              parentModal.find($("li[data-item-id='" + items[i] + "']"))
            );

            if (i === items.length - 1) {
              btnReset(currentButton);

              parentModal.find(".modal-info").removeClass("alert-info").addClass("alert-success");

              setTimeout(function () {
                parentModal.modal("hide");

                if (reloadURL !== undefined) {
                  location.replace(reloadURL + URLString);
                } else {
                  //location.reload(true);
                }
              }, 2000);
            }
          } else {
            console.log("error: ", result);
            $('<span class="text-danger">  <i class="fa fa-times-circle"></i> Fehler</span>').appendTo(
              parentModal.find($("li[data-item-id='" + items[i] + "']"))
            );
          }
          if (i++ < items.length - 1) {
            process(i);
          }
        },
        error: function () {
          console.log("ajax error");
        },
      });
    }

    process(0);
    return false;
  });
});
//# sourceMappingURL=main.js.map
